import React from 'react';
import { StyleSheet, View } from 'react-native';

import { theme } from '@sg/garnish';

import { GroupOrderBagButton } from '@order/features-group-ordering';

// ─────────────────────────────────────────────────────────────────────────────

export const GroupOrderConvertAction = (props: Props) => {
  const { isDisabled, onPress } = props;

  // ───────────────────────────────────────────────────────────────────────────

  return (
    <View style={styles.container}>
      <GroupOrderBagButton.Convert isDisabled={isDisabled} onPress={onPress} />
    </View>
  );
};

// ─── Styles ──────────────────────────────────────────────────────────────────

const styles = StyleSheet.create({
  container: {
    alignItems: 'flex-start',
    paddingTop: theme.spacing['6'],
    paddingBottom: theme.spacing['2'],
  },
});

// ─── Types ───────────────────────────────────────────────────────────────────

type Props = {
  isDisabled: boolean;
  onPress: () => void;
};
